
import React from 'react';
import CleanInterviewFormContainer from './form/CleanInterviewFormContainer';

interface CleanInterviewSubmissionFormProps {
  requestLink: string;
}

const CleanInterviewSubmissionForm: React.FC<CleanInterviewSubmissionFormProps> = ({ 
  requestLink 
}) => {
  if (!requestLink) {
    return (
      <div className="text-center py-8">
        <p className="text-red-600">Ingen gyldig forespørselslenke.</p>
      </div>
    );
  }
  return <CleanInterviewFormContainer requestLink={requestLink} />;
};

export default CleanInterviewSubmissionForm;
